import React, { useState, useEffect, useCallback, useRef } from "react";
import Card from "@mui/material/Card";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

import Table from "examples/Tables/Table";
import ClientSearch from "./Searchbar";
import NoData from "containers/DataNotAvailBox";
import { ClientRows_ } from "./ClientRows.js";
import moment from "moment";
import Searchbar from "containers/Searchbar";
import * as XLSX from "xlsx";
import {
  getServiceGstAmount,
  getServiceGstRate,
  getServiceReportBalance,
  getServiceTotalAmountIncludingGst,
  parseStrictNumber,
  timestampConversion,
} from "utils/common";
import { clearFilterState, appendClients } from "store/features/clients";
import { useDispatch } from "react-redux";
import { TailSpin } from "react-loader-spinner";
import { sortData } from "utils/sort";
import { firestoreOrDateToMillis } from "utils/serviceClientListHelpers";
import { validateExcelHeaders } from "validations";
import { validateClient } from "validations/client";
import { downloadErrorsAsTxt } from "utils/helper";
import { toast } from "react-toastify";
import { styled } from "@mui/material/styles";
import {
  excelAndDbClientFieldsMapping,
  leadOptions,
  paymentOptions,
  preferenceOptions,
  SERVICE_LIST_ONBOARD_PENDING_LABEL,
  serviceInstanceOptions,
} from "constant";
import { addMultipleClients } from "services/offering";
import { clearInputValueByDocId } from "utils/common";
import { updateFirstLetter } from "utils/helper";
import { isObject } from "utils/common";

const InputFile = styled("input")({
  display: "none",
});

function ClientTable({
  clients,
  loader,
  services,
  filterState,
  addHandler,
  editHandler,
  deleteHandler, 
  familyArray,
  filterFamilyMember,
  adminId,
  viewHandler,
  employees = [],
}) {
  const [rows, setRows] = useState([]); // rows for client table

  const [searchVal, setsearchVal] = useState(""); //storing search input text
  const [phoneFilterValue, setPhoneFilterValue] = useState(null); //storing search input text
  const [clientArray, setclientArray] = useState([]);
  let navigate = useNavigate(); //for navigation
  const [serviceOptions, setServiceOptions] = useState([]); //filtering wrt services
  const dispatch = useDispatch(); //for redux dispatch

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "",
    sortKey: "",
  });
  const [employeeArray, setEmployeeArray] = useState([]);

  // options for dropdown of service filter
  useEffect(() => {
    let serviceArray = services.map((item, index) => {
      return {
        value: item?.serviceName,
        label: item?.serviceName,
        totalAmount:
          (item?.sellingPriceWOT * item.gst) / 100 + item?.sellingPriceWOT,
        key: index,
        id: item?.id,
      };
    });
    setServiceOptions(serviceArray);
  }, [services]);
  useEffect(() => {
    const employeeArray_ = employees?.map((item, index) => {
      return {
        key: index,
        value: item.id,
        label: updateFirstLetter(item?.name),
        employeeName: item?.name,
        employeePhoneNumber: item?.phoneNumber,
        employeeEmail: item?.email,
      };
    });

    setEmployeeArray(employeeArray_);
  }, [employees]);
  const columns = [
    { name: "S.no", align: "left", width: "20px" },

    { name: "Date/Time", align: "left", sort: true, sortKey: "purchasedAt" },
    {
      name: "Client Name",
      align: "left",
      minWidth: "125px",
      sort: true,
      sortKey: "name",
    },
    {
      name: "Family Name",
      align: "left",
      minWidth: "125px",
      sort: true,
      sortKey: "familyName",
    },

    // { name: "Customer Id", align: "left", minWidth: "105px" },
    { name: "T&C Status", align: "left", minWidth: "105px" },
    { name: "Image Consent Status", align: "left", minWidth: "105px" },

    {
      name: "Phone",
      align: "left",
      minWidth: "120px",
      sort: true,
      sortKey: "phoneNumber",
    },
    {
      name: "Email",
      align: "left",
      minWidth: "115px",
      sort: true,
      sortKey: "email",
    },
    // { name: "Address", align: "left", minWidth: "120px" },
    // { name: "Gender", align: "left", minWidth: "120px" },
    // { name: "DOB", align: "left" },
    // { name: "Anniversary", align: "left" },
    // { name: "Age", align: "left" },
    // { name: "Occupation", align: "left", minWidth: "160px" },
    // { name: "Referred By", align: "left", minWidth: "120px" },
    // { name: "Food preference", align: "left", minWidth: "160px" },
    // { name: "Lead From", align: "left", minWidth: "120px" },
    // { name: "Commencement Date", align: "left", minWidth: "160px" },

    // { name: "Package", align: "left", minWidth: "120px" },
    // { name: "Completion Date", align: "left", minWidth: "150px" },
    // { name: "Total amount", align: "left", minWidth: "120px" },
    // { name: "Amount Paid", align: "left", minWidth: "120px" },
    // { name: "Discount", align: "left", minWidth: "120px" },

    // { name: "Balance", align: "left", minWidth: "120px" },
    // { name: "Payment Mode", align: "left", minWidth: "150px" },
    // { name: "Complementary Service", align: "left", minWidth: "180px" },

    // { name: "Service Type", align: "left", minWidth: "150px" },
    // { name: "Status", align: "left", minWidth: "120px" },
    { name: "Action", align: "left", minWidth: "105px" },
  ];

  useEffect(() => {
    const sortedRows = sortData(clientArray, sortConfig);

    setRows(
      ClientRows_(
        sortedRows,
        navigate,
        editHandler,
        deleteHandler,
        filterFamilyMember,
        viewHandler
      )
    );
  }, [
    clientArray,
    sortConfig,
    navigate,
    editHandler,
    deleteHandler,
    filterFamilyMember,
    viewHandler,
  ]);

  const handleSort = (name, sortKey) => {
    let direction = "asc";
    if (sortConfig.key === name && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key: name, direction, sortKey });
  };

  const [filterQuery, setFilterQuery] = useState({
    status: null,
    package: null,
    familyName: null,
    serviceInstance: null,
    fromDate: null,
    toDate: null,
  }); // for filtering

  //filtering on the basis of tile click handler
  const filterOnTileClick = useCallback(() => {
    let timestamp;

    const date = new Date();
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

    setFilterQuery((e) => {
      e["fromDate"] = firstDayOfMonth;
      e["toDate"] = date;
      return e;
    });

    let filterData = clients.filter((item) => {
      const rawTs = item.isOnboardPending
        ? item.clientRecordCreatedAt
        : item.purchasedAt;
      const ms = firestoreOrDateToMillis(rawTs);
      timestamp = moment.utc(ms ?? 0);

      if (
        new Date(firstDayOfMonth) >=
        new Date(moment(timestamp).format("YYYY-MM-DD"))
      ) {
        return false;
      }

      if (moment.utc(moment(date).add(24, "hours")).isBefore(timestamp)) {
        return false;
      }

      return item;
    });

    if (searchVal) {
      let filteredProduct = filterData.filter((s) => {
        let name = s?.name;
        return name.toLowerCase().includes(searchVal.toLowerCase());
      });
      setclientArray((e) => filteredProduct);
    } else {
      setclientArray(filterData);
    }

    dispatch(clearFilterState());
  }, [dispatch, clients, searchVal]);

  const filterHandler = () => {
    setsearchVal("");
    setPhoneFilterValue(null);
    let timestamp;
    let filterData = clients.filter((item) => {
      if (filterQuery.status) {
        if (filterQuery.status === "all") {
          setFilterQuery({ ...filterQuery, status: null });
        } else if (filterQuery.status !== item["status"]) {
          return false;
        }
      }

      if (filterQuery.service) {
        if (filterQuery.service === "all") {
          setFilterQuery({ ...filterQuery, service: null });
        } else if (filterQuery.service !== item["serviceName"]) {
          return false;
        }
      }

      if (filterQuery.familyName) {
        if (filterQuery.familyName === "all") {
          setFilterQuery({ ...filterQuery, familyName: null });
        } else if (filterQuery.familyName !== item["familyName"]) {
          return false;
        }
      }

      if (filterQuery.serviceInstance) {
        if (filterQuery.serviceInstance === "all") {
          setFilterQuery({ ...filterQuery, serviceInstance: null });
        } else if (filterQuery.serviceInstance !== item["serviceInstance"]) {
          return false;
        }
      }

      if (filterQuery.fromDate) {
        const rawTs = item.isOnboardPending
          ? item.clientRecordCreatedAt
          : item.purchasedAt;
        const ms = firestoreOrDateToMillis(rawTs);
        timestamp = moment.utc(ms ?? 0);
        if (
          new Date(filterQuery.fromDate) >
          new Date(moment(timestamp).format("YYYY-MM-DD"))
        ) {
          return false;
        }
      }

      if (filterQuery.toDate) {
        const rawTs = item.isOnboardPending
          ? item.clientRecordCreatedAt
          : item.purchasedAt;
        const ms = firestoreOrDateToMillis(rawTs);
        timestamp = moment.utc(ms ?? 0);
        if (
          moment
            .utc(moment(filterQuery.toDate).add(24, "hours"))
            .isBefore(timestamp)
        ) {
          return false;
        }
      }

      if (filterQuery.referredBy) {
        if (filterQuery.referredBy.label === "All") {
          setFilterQuery({ ...filterQuery, referredBy: null });
        } else {
          const referredByValue = isObject(item.referredBy)
            ? item.referredBy.label
            : item.referredBy;

          if (referredByValue !== filterQuery.referredBy.label) {
            return false;
          }
        }
      }

      if (filterQuery.assignDietitian) {
        if (filterQuery.assignDietitian === "all") {
          setFilterQuery({ ...filterQuery, assignDietitian: null });
        } else if (
          !item["assignDietitian"]?.some(
            (dietitian) => dietitian.value === filterQuery.assignDietitian
          )
        ) {
          return false;
        }
      }

      return item;
    });
    setclientArray(filterData);
  };

  const referredByOptions = Array.from(
    new Map(
      clients
        .filter((c) => c.referredBy)
        .map((c) => {
          const referred =
            typeof c.referredBy === "object"
              ? c.referredBy
              : { value: c.referredBy, label: c.referredBy };
          return [referred.value, referred];
        })
    ).values()
  );

  //for resetting filters
  const resetHandler = useCallback(() => {
    setFilterQuery({
      status: null,
      package: null,
      familyName: null,
      toDate: null,
      fromDate: null,
      serviceInstance: null,
    });
    setclientArray(clients);
  }, [clients]);

  //use for filter according to tile
  useEffect(() => {
    if (filterState.filter && clients.length > 0) {
      if (filterState?.state === "SERVICE") {
        filterOnTileClick(() => {
          const element = document.getElementById("product");
          if (element) {
            //will scroll smoothly to the top of the product section
            element.scrollIntoView({ behavior: "smooth" });
          }
        });
      } else {
        resetHandler();
        setclientArray(clients);
      }
    }
  }, [
    clients,
    resetHandler,
    setsearchVal,
    filterOnTileClick,
    filterState.state,
    filterState.filter,
  ]);

  //for searching

  const redirectState = useRef(filterState.redirect);
  useEffect(() => {
    if (searchVal) {
      resetHandler();
      let filteredProduct = clients.filter((s) => {
        let name = s?.name;
        return name.toLowerCase().includes(searchVal.toLowerCase());
      });
      setclientArray((e) => filteredProduct);
    } else if (phoneFilterValue) {
      resetHandler();
      let filteredProduct = clients.filter((s) => {
        let phone = String(s?.phoneNumber ?? "");
        return phone.includes(phoneFilterValue);
      });
      setclientArray(filteredProduct);
    } else {
      if (!redirectState.current) {
        redirectState.current = false;
        resetHandler();
        setclientArray(clients);
      }
    }
  }, [
    searchVal,
    resetHandler,
    setclientArray,
    dispatch,
    clients,
    phoneFilterValue,
  ]);

  const excelDownload = () => {
    const dataToExport = clientArray.length > 0 ? clientArray : clients;
    let updatedData = dataToExport.map((item, index) => {
      const totalAmount = getServiceTotalAmountIncludingGst(item);
      const amountPaid = parseStrictNumber(item.amountPaid);
      const gstRate = getServiceGstRate(item);
      const gstAmount = getServiceGstAmount(item);
      const discount = parseStrictNumber(item.discount);
      const balance = getServiceReportBalance(item);
      let time1 = item?.isOnboardPending
        ? SERVICE_LIST_ONBOARD_PENDING_LABEL
        : item?.purchasedAt?.seconds
        ? moment(timestampConversion(item?.purchasedAt))
            .local()
            .format("MMMM Do YYYY, h:mm a")
        : moment(item?.purchasedAt).local().format("MMMM Do YYYY, h:mm a");
      return [
        index + 1,
        time1,
        item.name,
        item.familyName ?? "N/A",
        item.customerId ?? "N/A",
        item.phoneNumber,
        item.email,
        item.address,
        item.gender === null ? "N/A" : item.gender,
        item.dob,
        item.age,
        item.occupation,
        item.referredBy,
        item.preference === null ? "N/A" : item.preference,
        item.leadFrom === null ? "N/A" : item.leadFrom,
        item.startDate,
        item.serviceName,
        item.completionDate,
        totalAmount,
        amountPaid,
        gstRate,
        gstAmount,
        discount,
        balance,
        item.paymentMode,
        item.complementaryService,
        item.serviceInstance,
        item.status,
      ];
    });
    let excelData = [
      [
        "id",
        "DATE/TIME",
        "CLIENT NAME",
        "FAMILY NAME",
        "CUSTOMER ID",
        "PHONE",
        "EMAIL",
        "ADDRESS",
        "GENDER",
        "DOB",
        "AGE",
        "OCCUPATION",
        "REFERRED BY",
        "FOOD PREFERENC",
        "LEAD FROM",
        "COMMENCEMENT DATE",
        "PACKAGE",
        "COMPLETION DATE",
        "TOTAL AMOUNT",
        "AMOUNT PAID",
        "GST(%)",
        "GST AMOUNT",
        "DISCOUNT",
        "BALANCE",
        "PAYMENT MODE",
        "COMPLEMENTARY SERVICE",
        "SERVICE TYPE",
        "STATUS",
      ],
      ...updatedData,
    ];

    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.json_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "MySheet");
    XLSX.writeFile(workbook, "Client_List_Services.xlsx");
  };

  const [excelUploadLoader, setExcelUploadLoader] = useState(false);

  const xmlEscape = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&apos;");

  const binaryStringToArrayBuffer = (binary) => {
    const buffer = new ArrayBuffer(binary.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < binary.length; i++) {
      view[i] = binary.charCodeAt(i) & 0xff;
    }
    return buffer;
  };

  const bytesToString = (bytes) => {
    let result = "";
    for (let i = 0; i < bytes.length; i++) {
      result += String.fromCharCode(bytes[i]);
    }
    return result;
  };

  const stringToBytes = (value) => {
    const bytes = new Uint8Array(value.length);
    for (let i = 0; i < value.length; i++) {
      bytes[i] = value.charCodeAt(i) & 0xff;
    }
    return bytes;
  };

  const downloadBinaryWorkbook = (binary, fileName) => {
    const blob = new Blob([binaryStringToArrayBuffer(binary)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const addDropdownValidationToWorkbook = (
    workbook,
    templateHeaders,
    dropdownColumns
  ) => {
    const workbookBinary = XLSX.write(workbook, {
      type: "binary",
      bookType: "xlsx",
    });
    const cfb = XLSX.CFB.read(workbookBinary, { type: "binary" });
    const worksheetFile = XLSX.CFB.find(cfb, "sheet1.xml");

    if (!worksheetFile?.content) {
      return workbookBinary;
    }

    const validations = Object.entries(dropdownColumns)
      .map(([fieldName, sourceRange]) => {
        const columnIndex = templateHeaders.findIndex(
          (header) => header.replace(/\s*\*+$/, "") === fieldName
        );
        if (columnIndex === -1 || !sourceRange) {
          return null;
        }

        const columnLetter = XLSX.utils.encode_col(columnIndex);
        return `<dataValidation type="list" allowBlank="1" showErrorMessage="1" sqref="${columnLetter}2:${columnLetter}1000"><formula1>${xmlEscape(
          sourceRange
        )}</formula1></dataValidation>`;
      })
      .filter(Boolean);

    if (!validations.length) {
      return workbookBinary;
    }

    const dataValidationsXml = `<dataValidations count="${validations.length}">${validations.join(
      ""
    )}</dataValidations>`;
    const currentWorksheetXml = bytesToString(worksheetFile.content);
    const worksheetXml = currentWorksheetXml.includes("<ignoredErrors>")
      ? currentWorksheetXml.replace(
          "<ignoredErrors>",
          `${dataValidationsXml}<ignoredErrors>`
        )
      : currentWorksheetXml.replace(
          "</worksheet>",
          `${dataValidationsXml}</worksheet>`
        );

    worksheetFile.content = stringToBytes(worksheetXml);

    return XLSX.CFB.write(cfb, { type: "binary", fileType: "zip" });
  };

  const handleExcelUpload = (e) => {
    e.preventDefault();
    var files = e.target.files,
      f = files[0];
    f && setExcelUploadLoader(true);

    var reader = new FileReader();
    reader.onload = async function (e) {
      var data = e.target.result;
      let readedData = XLSX.read(data, { type: "binary" });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataParse = XLSX.utils.sheet_to_json(ws, {
        header: 1,
        blankrows: false,
      });
      if (!validateExcelHeaders(dataParse, excelAndDbClientFieldsMapping)) {
        setExcelUploadLoader(false);
        clearInputValueByDocId("recipe-excel-file");
        return;
      }
      const { extractedData, errors } = await validateClient(
        dataParse,
        clientArray,
        serviceOptions,
        adminId
      );

      if (errors && errors.length > 0) {
        downloadErrorsAsTxt(errors, "service_errors.txt");
        toast.error(
          "Please check the errors in the downloaded file and try again!!"
        );
        setExcelUploadLoader(false);
        clearInputValueByDocId("recipe-excel-file");
        return;
      }

      if (!extractedData.length) {
        toast.error("No valid clients found to add.");
        setExcelUploadLoader(false);
        clearInputValueByDocId("recipe-excel-file");
        return;
      }

      try {
        const newClient = await addMultipleClients(extractedData);
        toast.success("Clients added successfully!!");
        dispatch(appendClients(newClient));
        setclientArray((e) => [...newClient, ...e]);
      } catch (error) {
        toast.error("Something went wrong!!");
      }
      setExcelUploadLoader(false);
      clearInputValueByDocId("recipe-excel-file");
    };
    f && reader?.readAsBinaryString(f);
  };

  const downloadExcelFile = async () => {
    const templateHeaders = excelAndDbClientFieldsMapping.map(
      (field) => `${field.excelName}${field.required ? " *" : ""}`
    );
    const requiredFields = excelAndDbClientFieldsMapping
      .filter((field) => field.required)
      .map((field) => field.excelName)
      .join(", ");
    const packageOptions = serviceOptions.map((service) => service.value);
    const dropdownSourceData = [
      ["Choose Package", "Service Instance", "Food Preference", "Lead From", "Payment Mode", "Gender"],
    ];
    const dropdownValueColumns = [
      packageOptions,
      serviceInstanceOptions.map((option) => option.value),
      preferenceOptions.map((option) => option.value),
      leadOptions.map((option) => option.value),
      paymentOptions.map((option) => option.value),
      ["Male", "Female", "Other"],
    ];
    const maxDropdownRows = Math.max(
      ...dropdownValueColumns.map((values) => values.length)
    );
    for (let i = 0; i < maxDropdownRows; i++) {
      dropdownSourceData.push(
        dropdownValueColumns.map((values) => values[i] ?? "")
      );
    }

    const dropdownSheetName = "Dropdown Values";
    const getDropdownRange = (columnIndex, values) => {
      if (!values.length) {
        return "";
      }
      const column = XLSX.utils.encode_col(columnIndex);
      return `'${dropdownSheetName}'!$${column}$2:$${column}${
        values.length + 1
      }`;
    };
    const dropdownColumns = {
      "Choose Package": getDropdownRange(0, packageOptions),
      "Service Instance": getDropdownRange(1, dropdownValueColumns[1]),
      "Food Preference": getDropdownRange(2, dropdownValueColumns[2]),
      "Lead From": getDropdownRange(3, dropdownValueColumns[3]),
      "Payment Mode": getDropdownRange(4, dropdownValueColumns[4]),
      Gender: getDropdownRange(5, dropdownValueColumns[5]),
    };
    const templateData = [templateHeaders];
    const optionRows = [
      ["Field", "Allowed Values"],
      ["Required marker", "Columns ending with * are mandatory."],
      ["Required fields", requiredFields],
      ["Choose Package", packageOptions.join(", ")],
      [
        "Service Instance",
        serviceInstanceOptions.map((option) => option.value).join(", "),
      ],
      [
        "Food Preference",
        preferenceOptions.map((option) => option.value).join(", "),
      ],
      [
        "Lead From",
        `Choose exactly one: ${leadOptions
          .map((option) => option.value)
          .join(", ")}`,
      ],
      ["Payment Mode", paymentOptions.map((option) => option.value).join(", ")],
      [
        "Discount Amount",
        "Plain amount only, for example 10, 15, 20. Do not format the cell as percentage.",
      ],
      ["Date Fields", "Use MM/DD/YYYY format"],
      [
        "Not in bulk upload",
        "Assign Dietitian, GST, Balance, Balance Receivable Date, and Total Amount are handled after upload or calculated by the app.",
      ],
    ];

    const workbook = XLSX.utils.book_new();
    const templateWorksheet = XLSX.utils.aoa_to_sheet(templateData);
    const optionsWorksheet = XLSX.utils.aoa_to_sheet(optionRows);
    const dropdownWorksheet = XLSX.utils.aoa_to_sheet(dropdownSourceData);

    templateWorksheet["!cols"] = templateHeaders.map((header) => ({
      wch: Math.max(header.length + 2, 14),
    }));
    optionsWorksheet["!cols"] = [{ wch: 24 }, { wch: 90 }];
    dropdownWorksheet["!cols"] = dropdownSourceData[0].map((header) => ({
      wch: Math.max(header.length + 2, 18),
    }));

    XLSX.utils.book_append_sheet(workbook, templateWorksheet, "Clients");
    XLSX.utils.book_append_sheet(workbook, optionsWorksheet, "Allowed Values");
    XLSX.utils.book_append_sheet(workbook, dropdownWorksheet, dropdownSheetName);

    const workbookWithDropdowns = addDropdownValidationToWorkbook(
      workbook,
      templateHeaders,
      dropdownColumns
    );
    downloadBinaryWorkbook(workbookWithDropdowns, "clients.xlsx");
  };

  return (
    <SuiBox mb={3}>
      <Card style={{ overflow: "inherit" }}>
        <SuiBox
          className="search-div"
          display="flex"
          justifyContent="space-between"
          flexWrap="wrap"
          alignItems="center"
          p={3}
          pb={1}
        >
          <SuiTypography display="flex" alignItems="center"></SuiTypography>
          <SuiBox
            className="search-box-div"
            style={{
              width: "80%",
              display: "flex",
              gap: 8,
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <Searchbar
              placeholder={"Search Client Name"}
              searchVal={searchVal}
              searchHandler={(e) => {
                setsearchVal((_) => e);
              }}
              style_={{ marginRight: 25, marginBottom: 10 }}
              clearHandler={() => {
                setsearchVal("");
              }}
            />

            <Searchbar
              placeholder={"Search Client Phone"}
              type="number"
              searchVal={phoneFilterValue}
              searchHandler={(e) => {
                setPhoneFilterValue((_) => e);
              }}
              style_={{ marginRight: 25, marginBottom: 10 }}
              clearHandler={() => {
                setPhoneFilterValue("");
              }}
            />

            <SuiBox mr={1}>
              <SuiButton
                component={Button}
                color="dark"
                variant="gradient"
                onClick={addHandler}
                width={180}
                style={{
                  marginRight: 25,
                  marginBottom: 10,
                  height: 40,
                  width: 230,
                  padding: 10,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Add Client
              </SuiButton>
            </SuiBox>

            <SuiBox mr={1}>
              <label htmlFor="recipe-excel-file" style={{ cursor: "pointer" }}>
                <InputFile
                  id="recipe-excel-file"
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleExcelUpload}
                />
                <SuiButton
                  ml={2}
                  component={SuiTypography}
                  color="dark"
                  variant="gradient"
                  onClick={(e) => e.stopPropagation()}
                >
                  Bulk Upload Clients
                  {excelUploadLoader && (
                    <TailSpin color="#17c1e8" height={17} width={17} />
                  )}
                </SuiButton>
              </label>
            </SuiBox>

            <SuiBox>
              <SuiButton
                component={Button}
                color="dark"
                variant="gradient"
                onClick={downloadExcelFile}
                width={180}
                style={styles.addProductButton}
              >
                Download excel template
              </SuiButton>
            </SuiBox>
          </SuiBox>
          <SuiTypography
            variant="button"
            fontWeight="regular"
            color={"dark"}
            sx={{ mt: 1 }}
          >
            Below are the list of clients who have taken your services, you can
            manage them all.
          </SuiTypography>
        </SuiBox>
        <ClientSearch
          serviceOptions={serviceOptions}
          setFilterQuery={setFilterQuery}
          filterHandler={filterHandler}
          filterQuery={filterQuery}
          resetHandler={resetHandler}
          excelDownload={excelDownload}
          familyArray={familyArray}
          referredByOptions={referredByOptions}
          dietitianOptions={employeeArray}
        />
        <SuiBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          {loader ? (
            <SuiBox
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: 30,
              }}
            >
              <TailSpin color="#17c1e8" height={60} width={60} />
            </SuiBox>
          ) : rows.length ? (
            <Table
              columns={columns}
              rows={rows}
              handleSort={handleSort}
              sortConfig={sortConfig}
            />
          ) : (
            <NoData />
          )}
        </SuiBox>
      </Card>
    </SuiBox>
  );
}

export default ClientTable;

/**-----------styles------------- */

const styles = {
  addProductButton: {
    marginRight: 25,
    marginBottom: 10,
    height: 40,
    width: 230,
    color: "#3A416F",
    padding: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
